import React, { useContext, useEffect, useRef, useState } from "react";
import Card from "../components/common/Card";
import logo from "./../images/EDVES-LOGO 2.png";
import defaultPic from "../images/defaultPic.png";
import Button from "../components/common/Button";
import { DataContext } from "../context/DataContext";
import { AuthContext } from "../context/AuthContext";
import { toTitleCase } from "../util/titleCase";
import { ForthSvg, BackSvg } from "../svg/BacknForthSvgs";
import Modal from "../components/common/ChatModal";
import SuccessModal from "../components/common/Modal";
import { useHistory } from "react-router-dom";

import classNames from "classnames";
import ReactHtmlParser, {
  convertNodeToElement,
  processNodes,
} from "react-html-parser";
import axios from "axios";

const OngoingTest = () => {
  const dataContext = useContext(DataContext);
  const authContext = useContext(AuthContext);
  const history = useHistory();
  const [clickedAns, setClickedAns] = useState(false);
  const [currQstNum, setCurrQstNum] = useState(1);
  const [currQst, setCurrQst] = useState(0);
  const [clickedOption, setClickedOption] = useState();
  const [answeredQsts, setAnsweredQsts] = useState([]);
  const [showSubmitModal, setShowSubmitModal] = useState(false);
  const [submitSuccessMsg, setSubmitSuccessMsg] = useState(false);
  const [successModal, setSuccessModal] = useState(false);
  const [score, setScore] = useState("");

  const studentInfo = JSON.parse(localStorage.getItem("studentInfo"));
  const admissionnumber = studentInfo[0].admissionnumber;
  const schoolDomain = localStorage.getItem("schoolDomain");
  // const LSAnsweredQsts = JSON.parse(localStorage.getItem('answeredQsts')); IsExamOngoing
  let storedAnsweredQsts;
  if (localStorage.getItem("answeredQsts") === null) {
    localStorage.setItem("answeredQsts", JSON.stringify([]));
  } else {
    storedAnsweredQsts = JSON.parse(localStorage.getItem("answeredQsts"));
  }
  const clickedCbtItem = JSON.parse(localStorage.getItem("clickedCbtItem"));
  const examQuestions = JSON.parse(localStorage.getItem("examQuestions"));
  const isExamOngoing = JSON.parse(
    localStorage.getItem("clickedCbtItem")
  ).IsExamOngoing;
  const getLSMins = localStorage.getItem("minutes");

  let [seconds, setSeconds] = useState(60);
  let [minutes, setMinutes] = useState(
    getLSMins ? getLSMins : clickedCbtItem.duration - 1
  );
  let [hours, setHours] = useState(0);
  let ongoingStoredAnsweredQsts = [];

  const clickedAnswrStyle = classNames({
    "radioBtnGray rounded-full mr-3 mb-5 radioBtnRadius": true,
  });
  const unClickedAnswrStyle =
    "radioBtnGray rounded-full mr-3 mb-5 border-2 border-gray-500";

  const backArrowStyle = classNames({
    "bg-blue-100 w-10 h-10 rounded-full mr-4 cursor-pointer": true,
    "opacity-50 cursor-not-allowed pointer-events-none": currQstNum === 1,
  });
  const fwrdArrowStyle = classNames({
    "bg-blue-100 w-10 h-10 rounded-full mr-4 cursor-pointer": true,
    "opacity-50 cursor-not-allowed pointer-events-none":
      currQstNum === examQuestions.length,
    // 'opacity-50 cursor-not-allowed pointer-events-none' : currQstNum === dataContext.examQuestions.length
  });

  function transform(node, index) {
    // all links must open in a new window
    if (node.type === "tag" && node.name === "a") {
      node.attribs.target = "_blank";
      return convertNodeToElement(node, index, transform);
    }

    if (node.type === "tag" && node.name === "button") {
      return (
        <Button key={index}>{processNodes(node.children, transform)}</Button>
      );
    }
  }

  const HtlmParserOptions = {
    decodeEntities: true,
    transform,
  };

  const handleClicked = (option) => {
    const configAnswrdQst = {
      qstNum: currQstNum,
      selectedOpt: option.id,
    };

    if (isExamOngoing || authContext.isExamOngoing) {
      const answrsMap = JSON.parse(localStorage.getItem("ongoingAnsweredQsts"));
      const newAnswered = answrsMap.map((item) =>
        item.qstNum === currQstNum ? { ...item, selectedOpt: option.id } : item
      );
      localStorage.setItem("ongoingAnsweredQsts", JSON.stringify(newAnswered));
    } else {
      if (storedAnsweredQsts.find((num) => num.qstNum === currQstNum)) {
        const newAnswered = storedAnsweredQsts.map((item) =>
          item.qstNum === currQstNum
            ? { ...item, selectedOpt: option.id }
            : item
        );
        localStorage.setItem("answeredQsts", JSON.stringify(newAnswered));
        // return newAnswered
        // return answered.map( item => (item.qstNum === currQstNum ? {...item, selectedOpt: option.id} : item));
      } else {
        const newAnswered = [...storedAnsweredQsts, configAnswrdQst];
        localStorage.setItem("answeredQsts", JSON.stringify(newAnswered));
        // return newAnswered
        // return [...answered, configAnswrdQst]
      }
    }
    console.log(ongoingStoredAnsweredQsts);

    // setAnsweredQsts(answered => {
    //     if (answered.find(num => num.qstNum === currQstNum)) {
    //         const newAnswered = answered.map( item => (item.qstNum === currQstNum ? {...item, selectedOpt: option.id} : item));
    //         localStorage.setItem('answeredQsts', JSON.stringify(newAnswered));
    //         return newAnswered
    //         // return answered.map( item => (item.qstNum === currQstNum ? {...item, selectedOpt: option.id} : item));
    //     } else {
    //         const newAnswered = [...answered, configAnswrdQst]
    //         localStorage.setItem('answeredQsts', JSON.stringify(newAnswered));
    //         return newAnswered
    //         // return [...answered, configAnswrdQst]
    //     }
    // });
    // localStorage.setItem('answeredQsts', JSON.stringify(answeredQsts))
    const submitAnsQueryBody = {
      // SchoolUrl: 'demo.edves.net',
      SchoolUrl: schoolDomain,
      // examidx: dataContext.clickedCbtItem.idx,
      examidx: clickedCbtItem.idx,
      admissionnumber,
      questionOptionId: option.id,
      questionidx: examQuestions[currQst].questionidx,
      // questionidx : dataContext.examQuestions[currQst].questionidx
    };
    const submitAnswer = async () => {
      try {
        const { data } = await axios.post(
          `student/updateexam`,
          submitAnsQueryBody
        );
        console.log(data.data);
      } catch (error) {
        console.log("submit question error", error);
      }
    };
    submitAnswer();
    console.log(configAnswrdQst);
    setClickedOption(option.id);
    setClickedAns(!clickedAns);
  };

  useEffect(() => {
    if (isExamOngoing || authContext.isExamOngoing) {
      examQuestions.map((question, index) => {
        return ongoingStoredAnsweredQsts.push({
          qstNum: index + 1,
          selectedOpt: question.choice,
        });
      });
      localStorage.setItem(
        "ongoingAnsweredQsts",
        JSON.stringify(ongoingStoredAnsweredQsts)
      );
      const ongoingExamDet = () => {
        const timeLeft = examQuestions[0].timeLeft;
        const mins = timeLeft.substring(3, 5);
        console.log(mins);
        const hrs = timeLeft.substring(1, 2);
        console.log(hrs);
        setMinutes(mins);
        setHours(hrs);
      };
      ongoingExamDet();
    }
  }, []);

  const examDetails = [
    {
      subject: toTitleCase(clickedCbtItem.subjectname),
      duration: `${clickedCbtItem.duration} minutes`,
      questions: examQuestions.length,
      class: clickedCbtItem.classx,
      term: toTitleCase(clickedCbtItem.termx),
      // subject: toTitleCase(dataContext.clickedCbtItem.subjectname),
      // duration: `${dataContext.clickedCbtItem.duration} minutes`,
      // questions: dataContext.examQuestions.length,
      // class: dataContext.clickedCbtItem.classx,
      // term: toTitleCase(dataContext.clickedCbtItem.termx)
    },
  ];

  const range = (start, end) => {
    return Array(end - start + 1)
      .fill()
      .map((_, idx) => start + idx);
  };

  // const qs = range(1, dataContext.examQuestions.length);
  const qs = range(1, examQuestions.length);

  let id = useRef(null);

  const stopTimer = () => {
    window.clearInterval(id.current);
    console.log("finish");
  };

  useEffect(() => {
    id.current = window.setInterval(() => {
      setSeconds((c) => c - 1);
    }, 1000);

    return stopTimer;
  }, []);

  const handleSubmitExam = async () => {
    stopTimer();
    setShowSubmitModal(false);

    const submitQueryBody = {
      // SchoolUrl: 'demo.edves.net',
      SchoolUrl: schoolDomain,
      // examidx: dataContext.clickedCbtItem.idx,
      examidx: clickedCbtItem.idx,
      admissionnumber,
    };
    try {
      const { data } = await axios.post("/student/submitexam", submitQueryBody);
      console.log(data.data);
      if (data.status) {
        localStorage.removeItem("minutes");
        localStorage.removeItem("answeredQsts");
        setSuccessModal(true);
        setTimeout(() => {
          setSuccessModal(false);
          data.data.Message.studentScore.length > 0
            ? setScore(data.data.Message.studentScore[0])
            : setScore("No score");
          // history.push('cbt')
        }, 1000);
      } else {
        alert("Unable to submit exam, please try again");
      }
    } catch (error) {
      console.log("Submit Exam Error", error);
      alert("Encountered an error while submitting exam, please try again.");
      setSubmitSuccessMsg(true);
    }
  };

  useEffect(() => {
    if (seconds < 2 && minutes < 1) {
      handleSubmitExam();
    }

    return () => {};
  }, [seconds, minutes]);

  if (seconds === 0) {
    setSeconds(59);
    setMinutes(minutes - 1);
  }

  useEffect(() => {
    localStorage.setItem("minutes", minutes);
    const timeTrackerQueryBody = {
      // SchoolUrl: 'demo.edves.net',
      SchoolUrl: schoolDomain,
      examidx: clickedCbtItem.idx,
      // examidx: dataContext.clickedCbtItem.idx,
      admissionnumber,
      timeLeft: minutes,
    };

    const updateTime = async () => {
      try {
        const { data } = await axios.post(
          "student/updatetimetracker",
          timeTrackerQueryBody
        );
        console.log("update time tracker", data.data);
      } catch (error) {
        console.log("time tracker querry error", error);
      }
    };
    updateTime();
  }, [minutes]);

  const paginationNavigator = (num) => {
    const idx = num - 1;
    setCurrQst(idx);
    setCurrQstNum(num);
    // console.log(currQst)
  };

  const handleBackwrdQstNav = () => {
    if (currQst !== 0) {
      setCurrQst((qst) => qst - 1);
    } else return;

    setCurrQstNum(currQstNum - 1);
  };

  const handleFrwdQstNav = () => {
    console.log(examQuestions.length);
    // if (currQst <= (dataContext.examQuestions.length - 2)) {
    if (currQst <= examQuestions.length - 2) {
      setCurrQst((qst) => qst + 1);
    } else return;
    setCurrQstNum(currQstNum + 1);
  };

  const onSubmit = () => {
    setShowSubmitModal(true);
  };

  const submitModalBtnAttr = {
    text: "Continue Exam",
    onClick: () => setShowSubmitModal(false),
  };
  const SubmitModalTitle = () => <>Are you sure you want to submit?</>;
  const whiteBtnAttr = {
    text: "Submit Exam",
    onClick: handleSubmitExam,
  };
  const SubmitModalBody = () => (
    <div className="mt-4 mb-1 text-gray-200 text-sm">
      Make sure you have attempted all questions before submitting. You may not
      be able to retake this exam after submitting
    </div>
  );
  const showModalStyling = classNames({
    "border-0 rounded-lg shadow-lg w-4/5 sm:w-2/5 p-6 relative flex flex-col mx-auto bg-white outline-none focus:outline-none": true,
  });

  const submitSuccessModalBody = () => (
    <div className="text-sm text-green-100 my-12 flex justify-center">
      Submitted Successfully!
    </div>
  );

  const scoreModalBody = () => (
    <div className="text-sm text-gray-800 my-12 flex justify-center">
      {score}
    </div>
  );

  const submitSuccessModalTitle = () => (
    <div className="text-base text-gray-100">Test Status</div>
  );

  const scoreModalTitle = () => (
    <div className="text-base text-gray-100">Your Score!</div>
  );

  const submitModalStyling = classNames({
    "border-0 rounded-lg shadow-lg w-64 p-8 relative mx-auto bg-white outline-none focus:outline-none": true,
  });

  const handleFinish = () => {
    setShowSubmitModal(true);
  };

  function addZero(n) {
    return (parseInt(n, 10) < 10 ? "0" : "") + n;
  }

  const handleCloseScoreModal = () => {
    setScore("");
    history.push("cbt");
  };

  return (
    <>
      {showSubmitModal && (
        <Modal
          closeModal={() => setShowSubmitModal(false)}
          modalStyling={showModalStyling}
          Title={SubmitModalTitle}
          Body={SubmitModalBody}
          whiteBtnAttr={whiteBtnAttr}
          BtnAttr={submitModalBtnAttr}
        />
      )}
      {successModal && (
        <SuccessModal
          closeModal={() => setSuccessModal(false)}
          Body={submitSuccessModalBody}
          Title={submitSuccessModalTitle}
          modalStyling={submitModalStyling}
        />
      )}
      {score !== "" && (
        <SuccessModal
          closeModal={handleCloseScoreModal}
          Body={scoreModalBody}
          Title={scoreModalTitle}
          modalStyling={submitModalStyling}
        />
      )}
      <nav className="flex fixed top-0 z-50 border-b border-gray-700 w-full justify-end sm:justify-between px-2 sm:px-6 bg-white h-16 items-center">
        <div className="hidden sm:block logoSize">
          <img src={logo} alt="logo" className="h-full w-full object-cover" />
        </div>
        <span className="hidden sm:block ml-16 text-gray-200 font-semibold text-sm leading-5">
          {" "}
          Edves Academy Student Portal{" "}
        </span>
        <div className="flex justify-between sm:justify-start items-center">
          <span
            onClick={handleFinish}
            className="bg-blue-800 mr-8 px-10 py-2 text-xs text-blue-100 font-semibold leading-4 cursor-pointer rounded-sm"
          >
            Finish
          </span>
          <div className="w-10 h-10">
            <img
              src={defaultPic}
              alt="logo"
              className="h-full w-full object-cover rounded-full"
            />
          </div>
        </div>
      </nav>
      <div className="flex flex-col sm:flex-row w-full">
        <div className="w-full sm:w-1/5 mt-24 sm:ml-6">
          <Card>
            <div className="rounded-lg px-4 py-6 w-full">
              <span className="hidden sm:block text-sm text-gray-100 leading-5 font-semibold">
                {" "}
                Exam Summary
              </span>
              {examDetails.map((exam, i) => (
                <div
                  key={i}
                  className="flex sm:flex-col sm:justify-start justify-between pb-4 border-b border-gray-600 sm:border-0"
                >
                  <div className="flex flex-col mt-5">
                    <span className="text-xs text-gray-200 font-semibold leading-4">
                      {" "}
                      Subject{" "}
                    </span>
                    <span className="text-xs sm:text-sm text-gray-300 font-semibold leading-4 opacity-50 mt-2">
                      {" "}
                      {exam.subject}{" "}
                    </span>
                  </div>
                  <div className="flex flex-col mt-5">
                    <span className="text-xs text-gray-200 font-semibold leading-4">
                      {" "}
                      Duration{" "}
                    </span>
                    <span className="text-xs sm:text-sm text-gray-300 font-semibold leading-4 opacity-50 mt-2">
                      {" "}
                      {exam.duration}{" "}
                    </span>
                  </div>
                  <div className="flex flex-col mt-5">
                    <span className="text-xs text-gray-200 font-semibold leading-4">
                      {" "}
                      Questions{" "}
                    </span>
                    <span className="text-xs sm:text-sm text-gray-300 font-semibold leading-4 opacity-50 mt-2">
                      {" "}
                      {exam.questions}{" "}
                    </span>
                  </div>
                  <div className="hidden sm:flex flex-col mt-5">
                    <span className="text-xs text-gray-200 font-semibold leading-4">
                      {" "}
                      Class{" "}
                    </span>
                    <span className="text-sm text-gray-300 font-semibold leading-4 opacity-50 mt-2">
                      {" "}
                      {exam.class}{" "}
                    </span>
                  </div>
                  <div className="hidden sm:flex flex-col mt-5">
                    <span className="text-xs text-gray-200 font-semibold leading-4">
                      {" "}
                      Term{" "}
                    </span>
                    <span className="text-sm text-gray-300 font-semibold leading-4 opacity-50 mt-2">
                      {" "}
                      {exam.term}{" "}
                    </span>
                  </div>
                </div>
              ))}
              <div className="sm:hidden rounded-lg py-6 w-full">
                <span className="text-sm text-gray-100 leading-5 font-semibold">
                  {" "}
                  Time Left{" "}
                </span>
                <div className="flex mt-5">
                  <div className="w-full p-3 bg-blue-900 flex rounded justify-center">
                    <div className="mr-3 flex">
                      <span className="text-blue-200 text-lg leading-8 font-medium mr-2">
                        {" "}
                        {hours}{" "}
                      </span>
                      <span className="text-xs text-gray-200 self-end">
                        {" "}
                        hours{" "}
                      </span>
                    </div>
                    <div className="mr-3 flex">
                      <span className="text-blue-200 text-lg leading-8 font-medium mr-2">
                        {" "}
                        {minutes}{" "}
                      </span>
                      <span className="text-xs text-gray-200 self-end">
                        {" "}
                        mins{" "}
                      </span>
                    </div>
                    <div className="mr-3 flex">
                      <span className="text-blue-200 text-lg leading-8 font-medium mr-2">
                        {" "}
                        {addZero(seconds)}{" "}
                      </span>
                      <span className="text-xs text-gray-200 self-end">
                        {" "}
                        secs{" "}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Card>
        </div>
        <div className="w-full sm:w-3/5 mt-4 sm:mt-24 sm:ml-6">
          <div className="sm:rounded-lg sm:shadow-lg sm:bg-white">
            <div className="w-full border-b border-gray-600 py-4 sm:py-6">
              {/* <span className='text-gray-200 text-sm font-semibold leading-5 px-6'> Question {currQstNum} of {dataContext.examQuestions.length} </span> */}
              <span className="text-gray-200 text-sm font-semibold leading-5 px-6">
                {" "}
                Question {currQstNum} of {examQuestions.length}{" "}
              </span>
            </div>
            <div
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              className="w-full rounded-lg px-6 py-6"
            >
              <div className="pb-4 mr-0 slideIn">
                {/* <span className='font-bold text-gray-100 text-sm sm:text-base leading-5'> {ReactHtmlParser(dataContext.examQuestions[currQst].question, options)} </span> */}
                <span className="font-bold text-gray-100 text-sm sm:text-base leading-5">
                  {" "}
                  {ReactHtmlParser(
                    examQuestions[currQst].question,
                    HtlmParserOptions
                  )}{" "}
                </span>
              </div>
              {/* {dataContext.examQuestions[currQst].cbtExamsQuestionsOption.map((option) => { */}
              {examQuestions[currQst].cbtExamsQuestionsOption.map((option) => {
                // const answered = answeredQsts.find(qsts => qsts.qstNum === currQstNum)
                const answrsMap = storedAnsweredQsts
                  ? storedAnsweredQsts
                  : answeredQsts;
                const answered = answrsMap.find(
                  (qsts) => qsts.qstNum === currQstNum
                ); // isExamOngoing ? examQuestions[currQst].choice === option.id
                const markOption = () => {
                  if (isExamOngoing || authContext.isExamOngoing) {
                    const answrsMap = JSON.parse(
                      localStorage.getItem("ongoingAnsweredQsts")
                    );
                    const answered =
                      answrsMap &&
                      answrsMap.find((qsts) => qsts.qstNum === currQstNum);
                    // const answered = ongoingStoredAnsweredQsts.find(qsts => qsts.qstNum === currQstNum);
                    return answered && option.id === answered.selectedOpt
                      ? clickedAnswrStyle
                      : unClickedAnswrStyle;
                  } else {
                    return answered && option.id === answered.selectedOpt
                      ? clickedAnswrStyle
                      : unClickedAnswrStyle;
                  }
                };
                return (
                  <div
                    key={option.id}
                    onClick={() => handleClicked(option)}
                    className="flex cursor-pointer slideIn"
                  >
                    <span className={markOption()}></span>
                    <span className="font-medium text-sm text-gray-200 leading-5 slideIn mr-3">
                      {" "}
                      {option.optionLabel}.{" "}
                    </span>
                    <span className="font-normal text-sm text-gray-200 leading-5 slideIn mr-3">
                      {" "}
                      {ReactHtmlParser(option.option, HtlmParserOptions)}{" "}
                    </span>
                  </div>
                );
              })}
            </div>
            <div className="w-full justify-center items-center flex mt-8 sm:mt-6 pb-8">
              <div onClick={handleBackwrdQstNav} className={backArrowStyle}>
                <BackSvg />
              </div>
              <div className="mr-4">
                <Button text="Submit" onClick={onSubmit} />
              </div>
              <div onClick={handleFrwdQstNav} className={fwrdArrowStyle}>
                <ForthSvg />
              </div>
            </div>
          </div>
        </div>
        <div className="hidden w-1/5 mt-24 ml-6 sm:flex flex-col mr-6">
          <Card>
            <div className="rounded-lg px-4 py-6">
              <span className="text-sm text-gray-100 leading-5 font-semibold">
                {" "}
                Time Left{" "}
              </span>
              <>
                <div className="flex mt-5">
                  <div className="w-full p-3 bg-blue-900 flex sm:flex-col lg:flex-row justify-center rounded">
                    <div className="mr-3 flex">
                      <span className="text-blue-200 text-lg md:text-2xl lg:text-4xl leading-8 font-medium mr-1">
                        {" "}
                        {hours}{" "}
                      </span>
                      <span className="text-xs text-gray-200 md:mb-1 lg:mb-0 self-end">
                        {" "}
                        hours{" "}
                      </span>
                    </div>
                    <div className="mr-3 flex">
                      <span className="text-blue-200 md:text-2xl lg:text-4xl leading-8 font-medium mr-1">
                        {" "}
                        {minutes}{" "}
                      </span>
                      <span className="text-xs text-gray-200 md:mb-1 sm:mb-0 lg:mb-0 self-end">
                        {" "}
                        mins{" "}
                      </span>
                    </div>
                    <div className="mr-3 flex">
                      <span className="text-blue-200 md:text-2xl lg:text-4xl leading-8 font-medium mr-1">
                        {" "}
                        {addZero(seconds)}{" "}
                      </span>
                      <span className="text-xs text-gray-200 md:mb-1 sm:mb-0 lg:mb-0 self-end">
                        {" "}
                        secs{" "}
                      </span>
                    </div>
                  </div>
                </div>
              </>
            </div>
          </Card>
          <div className="w-full mt-4 mr-6">
            <Card>
              <div className="rounded-lg px-4 py-6">
                <span className="text-sm text-gray-100 leading-5 font-semibold">
                  {" "}
                  Progress{" "}
                </span>
                <div className="flex flex-wrap w-full mt-2">
                  {qs.map((num) => {
                    // const answered = answeredQsts.find(qsts => qsts.qstNum === num)
                    let ongoingAnswered;
                    if (isExamOngoing || authContext.isExamOngoing) {
                      const answrsMap = JSON.parse(
                        localStorage.getItem("ongoingAnsweredQsts")
                      );
                      ongoingAnswered =
                        answrsMap &&
                        answrsMap.find(
                          (qst) => qst.qstNum === num && qst.selectedOpt !== "0"
                        );
                      // ongoingAnswered = ongoingStoredAnsweredQsts.find(qsts => qsts.qstNum === currQstNum);
                    }
                    const answrsMap = storedAnsweredQsts
                      ? storedAnsweredQsts
                      : answeredQsts;
                    const answered = answrsMap.find(
                      (qsts) => qsts.qstNum === num
                    );
                    const paginationStyle = classNames({
                      "w-6 h-6 rounded-full text-xs flex justify-center items-center": true,
                      "bg-blue-200 text-white":
                        isExamOngoing || authContext.isExamOngoing
                          ? ongoingAnswered
                          : answered,
                      "bg-gray-700 text-gray-200":
                        isExamOngoing || authContext.isExamOngoing
                          ? !ongoingAnswered
                          : !answered,
                      "border border-blue-100 text-gray-200":
                        num === currQstNum,
                      "text-white":
                        (num === currQstNum && ongoingAnswered) || answered,
                    });
                    return (
                      <>
                        <div className="mt-3 mr-2 cursor-pointer">
                          <span
                            onClick={() => paginationNavigator(num)}
                            className={paginationStyle}
                          >
                            {num}
                          </span>
                        </div>
                      </>
                    );
                  })}
                </div>
              </div>
            </Card>
          </div>
        </div>
      </div>
    </>
  );
};

export default OngoingTest;
